import {createSelector} from "reselect";

const groups = (state) => state.group;

const groupsData = createSelector(groups, (data) => data?.groupData || {});

export const getGroupsList = createSelector(groupsData, (data) => data?.results || []);

export const getTotalCount = createSelector(groupsData, (data) => data?.count);

export const getGroupsPaginationUrls = createSelector(groupsData, (data) => ({
  prevUrl: data?.previous,
  nextUrl: data?.next,
}));

export const getPermissionList = createSelector(
  groups,
  (groups) => groups.permissions_list
);
export const getGroupModalStatus = createSelector(
  groups,
  (groups) => groups.groupModalStatus
);

export const getGroupModalData = createSelector(
  groups,
  (groups) => groups.groupModalData
);
export const getUsersList = createSelector(groups, (groups) => groups.users_list);
